// extracted by mini-css-extract-plugin
module.exports = {"container":"CDYetmQsKOtme4hb5Q8A9","labelWrapper":"_3C5IOLYCnOrQxEunKFVfQt","label":"_3CuJpaqh0h12I1j7Rk_JgH","input":"_35RXBkKNxGxXq4X87ztAOD"};